<template>
  <div class="start-trip-card" @click="goToDiscover">
    <transition name="fade-in">
      <div class="start-trip-card__content">
        <span>+</span>
        Start a New Trip
      </div>
    </transition>
  </div>
</template>

<script>
import {RouterAliases} from '@/router/routerAliases';

export default {
  name: 'AmexMyTripsStart',
  methods: {
    goToDiscover() {
      this.$router.push({name: RouterAliases.DISCOVERY_VIEW});
    },
  },
};
</script>

<style lang="scss" scoped>
.start-trip-card {
  border-radius: 20px;
  background-color: #fff;
  color: #fff;
  width: 100%;
  height: auto;
  padding-left: 0;
  overflow: hidden;
  position: relative;
  display: block;
  border: 1px solid var(--primary-color, hsl(208, 100%, 41%));
  appearance: none;
  text-align: left;
  box-shadow: 0 0 33px rgba(0, 0, 0, 0.13);
  max-width: 350px;

  &:hover {
    cursor: pointer;
  }

  &__content {
    background-color: var(--primary-color, hsl(208, 100%, 41%));
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 192px;
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
    gap: 20px;
    height: 100%;

    span {
      font-size: 56px;
      font-weight: 300;
    }
  }
}
</style>
